import { render, staticRenderFns } from "./Section6.vue?vue&type=template&id=54ae6e4f&scoped=true&"
import script from "./Section6.vue?vue&type=script&lang=js&"
export * from "./Section6.vue?vue&type=script&lang=js&"
import style0 from "./Section6.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Section6.vue?vue&type=style&index=1&id=54ae6e4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae6e4f",
  null
  
)

export default component.exports